<template>
  <div v-if="visible" id="tab-hbl">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-dropdown
            no="1"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1)}"
          >
            {{ command1 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.CodeSearching')">{{ $t('SeaExport.CodeSearching') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromTheLastTime')">{{ $t('SeaExport.CopyFromTheLastTime') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromOtherBill')">{{ $t('SeaExport.CopyFromOtherBill') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyCargoDescriptionAndMarks')">{{ $t('SeaExport.CopyCargoDescriptionAndMarks') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyMbl')">{{ $t('SeaExport.CopyMbl') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            no="2"
            :disabled="btnPrintDisabled"
            type="primary"
            @click="originalPrint"
          >{{ form.releaseType === 1 ? $t('SeaExport.PrintTheOriginalBl') : $t('SeaExport.TelexRelease') }}</el-button>
          <el-button v-show="readonly && form.state==2 " no="3" type="primary" :disabled="!readonly&&unlockDisabled" @click="pm.onSubmitStateEvent()">{{ $t('SeaExport.Unlock') }}</el-button>
          <el-button
            no="4"
            :disabled="readonly||!form.uuid"
            type="primary"
            @click="showAddressFormatDialog"
          >{{ $t('SeaExport.AntiTerroristFormattedAddress') }}</el-button>
          <el-button
            v-if="viewSource === 'SiBooking'"
            v-permission="['button_insurance_toInsure']"
            no="5"
            :disabled="isEdit"
            type="primary"
            @click="pm.toInsure()"
          >{{ $t('SeaExport.Insure') }}</el-button>
          <el-checkbox no="6" :value="form.state===2" :disabled="true" style="margin-left: 10px;">{{ $t('Message.Locked') }}</el-checkbox>
          <el-checkbox v-model="form.oversea" no="7" :disabled="readonly" style="margin-left: -20px;">{{ $t('SeaExport.BlBeReleasedElsewhereOrNot') }}</el-checkbox>
          <el-checkbox v-model="form.manifestEDI" no="8" :disabled="readonly" style="margin-left: -20px;">{{ $t('SeaExport.ManifestEdi') }}</el-checkbox>
          <el-checkbox v-model="form.printParam1" no="9" :disabled="readonly" style="margin-left: -20px;">Part of</el-checkbox>
          <el-checkbox v-model="form.printParam2" no="10" :disabled="readonly" style="margin-left: -20px;">{{ $t('SeaExport.ClauseOfNoWoodPackingMaterial') }}</el-checkbox>
          <!--          <el-checkbox-->
          <!--            v-model="form.printParam3"-->
          <!--            :disabled="readonly"-->
          <!--            @change="val=>{pm.chargeContainer(val)}"-->
          <!--          >箱封号后跟件数毛重体积</el-checkbox>-->
          <el-checkbox v-model="form.chkConsolidationClosed" no="11" :disabled="readonly" style="margin-left: -20px;">{{ $t('SeaExport.AFRTheLastBill') }}</el-checkbox>
          <el-checkbox v-model="form.printParam6" no="12" :disabled="readonly" style="margin-left: -20px;">{{ $t('SeaExport.PrintBargeVesselAndVoyage') }}</el-checkbox>
          <el-checkbox
            no="13"
            style="margin-left: -20px;"
            :value="form.customerSelfRelease===1"
            :disabled="readonly"
            @input="val=>{pm.isCustomerSelfRelease(val)}"
          >{{ $t('SeaExport.CustomerSelfRelease') }}</el-checkbox>
          <el-checkbox
            no="14"
            style="margin-left: -20px;"
            :value="form.customerSelfRelease===2"
            :disabled="readonly"
            @input="val=>{pm.isCompanySelfRelease(val)}"
          >{{ $t('SeaExport.CompanySelfRelease') }}</el-checkbox>
        </div>
      </div>
    </div>
    <div style="width: fit-content">
      <div style="display: flex">
        <div class="down-first section form-column">
          <el-form :label-width="isZh ? '70px' : '75px'" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.ConsigneeShipperAndNotifyInfo') }}</span>
            <el-form-item class="auto-width">
              <template slot="label">
                <span>{{ $t('SeaExport.Shipper') }}</span>
                <char-count :form="form" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
              </template>
              <div style="display: flex;">
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  v-model="form.shipperCode"
                  :disabled="readonly"
                  no="15"
                  style="flex: 1"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  no="16"
                  :disabled="readonly"
                  :select-type="selectTypeNames.basic_data_Company"
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  :method-params="{partnerManagementMode,branchId:$store.getters.currentOfficeId,shipper:true}"
                  filterable
                  :default-value="form.shipperId||''"
                  tag-name="englishName"
                  style="flex: 1"
                  @parentCallBack="p=>{senderAndReceiverChange('shipper',p, 7)}"
                />
                <el-button type="primary" style="margin-left: 5px" @click="clearSenderAndReceiver('shipper',7)">{{ $t('SeaExport.Reset') }}</el-button>
              </div>
            </el-form-item>

            <el-form-item
              v-for="count in 7"
              :key="'shipperLine'+count"
              :class="'auto-width ' + getSenderAndReceiverColor('shipperLine',count)"
            >
              <cargo-input
                :ref="'shipperLine'+count"
                v-model="form['shipperLine'+count]"
                :disabled="readonly"
                :no="'shipperLine'+count"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                @dblclick.native="showSenderAndReceiverDialog('shipper',7, false, notUppercaseShipperConsigneNotify)"
                @change="()=>wrapAddr(form,'shipperLine'+count,count+1 > 7 ? null :'shipperLine'+(count+1),maxChars)"
              />
            </el-form-item>
            <el-form-item class="auto-width">
              <template slot="label">
                <span>{{ $t('SeaExport.Consignee') }}</span>
                <char-count :form="form" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" />
              </template>
              <div style="display: flex;">
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  v-model="form.consigneeCode"
                  :disabled="readonly"
                  no="17"
                  style="flex: 1"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  no="18"
                  :disabled="readonly"
                  :select-type="selectTypeNames.basic_data_Company"
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  :method-params="{partnerManagementMode,branchId:$store.getters.currentOfficeId,consignee:true}"
                  filterable
                  :default-value="form.consigneeId||''"
                  tag-name="englishName"
                  style="width:157px;flex: 1"
                  @parentCallBack="p=>{senderAndReceiverChange('consignee',p, 7)}"
                />
                <el-button no="19" :disabled="readonly" type="primary" style="margin-left: 5px" @click="clearSenderAndReceiver('consignee',7)">{{ $t('SeaExport.Reset') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'consigneeLine'+count"
              :class="'auto-width ' + getSenderAndReceiverColor('consigneeLine',count)"
            >
              <cargo-input
                :ref="'consigneeLine'+count"
                v-model="form['consigneeLine'+count]"
                :disabled="readonly"
                :no="'consigneeLine'+count"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                @dblclick.native="showSenderAndReceiverDialog('consignee',7,false, notUppercaseShipperConsigneNotify)"
                @change="()=>wrapAddr(form,'consigneeLine'+count,count+1 > 7 ? null :'consigneeLine'+(count+1),maxChars)"
              />
            </el-form-item>
            <el-form-item class="auto-width">
              <template slot="label">
                <span>{{ $t('SeaExport.NotifyParty') }}</span>
                <char-count :form="form" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
              </template>
              <div style="display: flex;">
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  v-model="form.notifyCode"
                  :disabled="readonly"
                  no="20"
                  style="flex: 1;width: 120px"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  no="21"
                  :disabled="readonly"
                  :select-type="selectTypeNames.basic_data_Company"
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  :method-params="{partnerManagementMode,branchId:$store.getters.currentOfficeId,notify:true}"
                  filterable
                  :default-value="form.notifyId||''"
                  tag-name="englishName"
                  style="flex: 1;width: 120px"
                  @parentCallBack="p=>{senderAndReceiverChange('notify',p, 7)}"
                />
                <el-button no="22" :disabled="readonly" type="primary" style="margin-left: 5px;" @click="clearSenderAndReceiver('notify',7)">{{ $t('SeaExport.Reset') }}</el-button>
                <el-button no="23" :disabled="readonly" type="primary" style="margin-left: 5px" @click="pm.onCopy_consignee()">{{ $t('SeaExport.CopyTheConsignee') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'notifyLine'+count"
              :class="'auto-width ' + getSenderAndReceiverColor('notifyLine',count)"
            >
              <cargo-input
                :ref="'notifyLine'+count"
                v-model="form['notifyLine'+count]"
                :disabled="readonly"
                :no="'notifyLine'+count"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                @dblclick.native="showSenderAndReceiverDialog('notify',7,false, notUppercaseShipperConsigneNotify)"
                @change="()=>wrapAddr(form,'notifyLine'+count,count+1 > 7 ? null :'notifyLine'+(count+1),maxChars)"
              />
            </el-form-item>
            <el-form-item class="auto-width">
              <span slot="label" style="color:#404144!important;">{{ $t('SeaExport.AgentInfo') }}</span>
              <div style="text-align: right">
                <el-button no="24" type="primary" :disabled="readonly" style="min-width:50px;margin-right: 5px" @click="pm.onClear(4)">{{ $t('SeaExport.Reset') }}</el-button>
                <el-dropdown
                  no="25"
                  :class="readonly?'not-click':''"
                  :disabled="readonly"
                  split-button
                  type="primary"
                  @click="commandHandle(command3)"
                  @command="p=>{this.command3=p;commandHandle(command3)}"
                >
                  {{ command3 }}
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="$t('SeaExport.CopyMblConsignee')">{{ $t('SeaExport.CopyMblConsignee') }}</el-dropdown-item>
                    <el-dropdown-item :command="$t('SeaExport.CopyNominatedAgentInfo')">{{ $t('SeaExport.CopyNominatedAgentInfo') }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'agentPartyLine'+count"
              :class="'auto-width ' + getSenderAndReceiverColor('agentPartyLine',count)"
            >
              <cargo-input
                :ref="'agentPartyLine'+count"
                v-model="form['agentPartyLine'+count]"
                :disabled="readonly"
                :no="'agentPartyLine'+count"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                @dblclick.native="showSenderAndReceiverDialog('agentParty',7,false, notUppercaseShipperConsigneNotify)"
                @change="()=>wrapAddr(form,'agentPartyLine'+count,count+1 > 7 ? null :'agentPartyLine'+(count+1),maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0">
              <span style="color:#404144">ALSO NOTIFY</span>
            </el-form-item>
            <el-form-item class="auto-width">
              <cargo-rich-textarea
                v-model="form.alsoNotify"
                no="26"
                :disabled="!isEdit"
                :text-chars="maxChars"
                :warning-count="warningCount"
                :use-read-only="true"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{ form.alsoNotify= notUppercaseShipperConsigneNotify ? val.toUpperCase() : val},false, null, notUppercaseShipperConsigneNotify)"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="down-two section form-column">
          <el-form :disabled="readonly" :label-width="isZh ? '125px' : '160px'" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.CargoInfo') }}</span>
            <el-form-item :label="$t('SeaExport.NumberOfPackagesOnBl')">
              <auto-number-input
                v-model="form.quantity"
                no="27"
                :precision="0"
                :min="0"
                :disabled="isCrossTenantSEToSI"
                @change="pm.quantity_Change()"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Package')" :class="variableCss.packing">
              <!-- <cargo-advance-select
                :select-type="selectTypeNames.basic_data_Packing"
                filterable
                :default-value="form.packing"
                style="width:100%;"
                @parentCallBack="p=>{pm.packing_Change(p)}"
              /> -->
              <cargo-packing-select
                no="28"
                :default-value="form.packing"
                :disabled="isCrossTenantSEToSI"
                @change="p => {pm.packing_Change(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Pieces2')" :class="variableCss.insideQuantity">
              <auto-number-input
                v-model="form.insideQuantity"
                no="29"
                :precision="0"
                :min="0"
                :disabled="isCrossTenantSEToSI"
                @change="pm.insideQuantity_Change($event)"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PiecesType2')" :class="variableCss.insidePacking">
              <!-- <cargo-advance-select
                :select-type="selectTypeNames.basic_data_Packing"
                filterable
                :default-value="form.insidePacking"
                style="width:100%;"
                @parentCallBack="p=>{form.insidePacking=p.value}"
              /> -->
              <cargo-packing-select
                no="30"
                :default-value="form.insidePacking"
                :disabled="isCrossTenantSEToSI"
                @change="p => {form.insidePacking=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.GrossWeight')" :class="'custom '+variableCss.weight">
              <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
                <auto-number-input
                  v-model="form.weight"
                  no="31"
                  :disabled="!pm.isCanEditQwc || isCrossTenantSEToSI"
                  :precision="3"
                  :min="0"
                  @change="p=>{pm.txtWeightChargeHandler();}"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Cubage')" :class="'custom '+variableCss.cubage">
              <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
                <auto-number-input
                  v-model="form.cubage"
                  no="32"
                  :disabled="!pm.isCanEditQwc || isCrossTenantSEToSI"
                  :precision="3"
                  :min="0"
                  @change="p=>{pm.txtCubageChargeHandler();}"
                />
                <span>CBM</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChargedWeightRT')" class="custom">
              <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
                <auto-number-input
                  v-model="form.chargeWeight"
                  no="33"
                  :precision="3"
                  :min="0"
                  :disabled="isCrossTenantSEToSI"
                  @change="pm.txtChargeWeightHandler()"
                />
                <span>M/T</span>
              </div>
            </el-form-item>
            <el-form-item class="custom">
              <el-button
                v-show="isEdit"
                no="34"
                type="primary"
                style="float:right"
                @click="pm.getMBLInfo('EName')"
              >{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromMbl') }}</el-button>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_EnglishCargoName')" :class="'label-none custom '+variableCss.cargoEnglishName">
              <cargo-rich-textarea
                v-model="form.cargoEnglishName"
                no="35"
                :show-count="true"
                :disabled="!isEdit || isCrossTenantSEToSI"
                :text-chars="englishNameMaxChars"
                :warning-count="englishNameWarningCount"
                style="height: 110px;"
                :auto-uppercase="isUppercaseByConfig"
                @change="pm.txtCargoEnglishNameChangeHandler()"
                @dblclick.native="showAdvanceTextDialog($t('queryJob.englishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val},false,null,isUppercaseByConfig , {
                  warningCount: englishNameWarningCount,
                  maxChar: englishNameMaxChars
                })"
              />
            </el-form-item>
            <el-form-item class="custom">
              <el-button
                v-show="isEdit"
                no="36"
                type="primary"
                style="float:right;margin-left:5px"
                @change="pm.txtMarkChangeHandler()"
                @click="pm.getMBLInfo('mark')"
              >{{ $t('SeaExport.CopyMarksFromMbl') }}</el-button>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Marks')" :class="'label-none custom '+variableCss.mark">
              <cargo-rich-textarea
                v-model="form.mark"
                no="37"
                :show-count="true"
                :disabled="!isEdit || isCrossTenantSEToSI"
                :text-chars="markMaxChars"
                :warning-count="markWarningCount"
                style="height: 110px;"
                :auto-uppercase="isUppercaseByConfig"
                @change="pm.txtMarkChangeHandler($event)"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val},false,null,isUppercaseByConfig , {
                  warningCount: markWarningCount,
                  maxChar: markMaxChars
                })"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CapitalizedNumbersOfPackages')" class="label-none custom">
              <el-input v-model="form.quantitySum" no="38" :disabled="true" />
            </el-form-item>
          </el-form>
        </div>
        <div class="down-three section form-column">
          <el-form :disabled="readonly" :label-width="isZh ? '100px' : '120px'" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.TransportInfo') }}</span>
            <el-form-item label="HB/L NO.">
              <el-input v-model="form.hblNbr2" no="39" :disabled="hblNoDisabled || isCrossTenantSEToSI" @change="pm.hblFunction($event)" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillOfLadingNumber')">
              <el-input v-model="form.serialNo" no="40" />
            </el-form-item>
            <el-form-item :label="$t('Payment.vessel')">
              <cargo-advance-select
                no="41"
                :disabled="readonly||!pm._lclslaveEnabled || isCrossTenantSEToSI"
                :select-type="selectTypeNames.basic_data_Vessel"
                filterable
                clearable
                :allow-create="pm._allowEditingVessel"
                :default-value="job.vessel"
                style="width:100%;"
                @parentCallBack="p=>{pm.onVesselSelectionChange(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.voyage')">
              <el-select
                ref="voyageFlight"
                v-model="job.voyageFlight"
                no="42"
                :disabled="readonly||!pm._lclslaveEnabled || isCrossTenantSEToSI"
                filterable
                clearable
                :allow-create="pm.editVoyageMode===1"
                @focus="pm.voyageFocusInHandler()"
                @blur="pm.voyageFocusOutHandler()"
              >
                <el-option
                  v-for="(item,index) in pm._voyages"
                  :key="index"
                  :label="item.voyageNo"
                  :value="item.voyageNo"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('queryJob.dateOfDeparture')">
              <el-input no="43" :value="job.etd ? moment(job.etd).format('YYYY-MM-DD') : null" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocDispatchingPlace')" :class="variableCss.dispatchingPlace">
              <el-input v-model="form.dispatchingPlace" no="44" :disabled="isCrossTenantSEToSI" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfLoadingOnBl')" :class="variableCss.loadingPort">
              <el-input v-model="form.loadingPort" no="45" :disabled="isCrossTenantSEToSI" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfDischargeOnBl')" :class="variableCss.dischargingPort">
              <el-input v-model="form.dischargingPort" no="46" :disabled="isCrossTenantSEToSI" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfDeliveryOnBl')" :class="variableCss.destinationPort">
              <el-input v-model="form.destinationPort" no="47" :disabled="isCrossTenantSEToSI" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MethodOfHblPayment')">
              <cargo-advance-select
                no="48"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                filterable
                :default-value="job.paymentTermHBL"
                style="width:100%;"
                :disabled="isCrossTenantSEToSI"
                @parentCallBack="p=>{pm.paymentSelectHblChange(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfHblPayment2')">
              <el-input v-model="form.paymentPlaceBL" no="49" :disabled="isCrossTenantSEToSI" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TransportationClause')">
              <el-input v-model="form.freightTermHBL" no="50" :disabled="isCrossTenantSEToSI" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.NoOfOriginalBls')" :class="variableCss.blNumber">
              <el-input v-model="form.blNumber" no="51" :disabled="isCrossTenantSEToSI" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfIssue')">
              <el-input v-model="form.signPlaceBL" no="52" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfIssue')">
              <el-date-picker v-model="form.signDateBL" no="53" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlRemarks')" :class="variableCss.remarks">
              <cargo-rich-textarea
                v-model="form.remarks"
                no="54"
                :disabled="!isEdit"
                :text-chars="0"
                :warning-count="-1"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.BlRemarks'),form.remarks,val=>{form.remarks=val}, false, null, false,{
                  warningCount: -1,
                  maxChar: 0,
                  autoUppercase: false,
                  autoHalfWord: false
                })"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HsCode')">
              <el-input
                v-model="job.hsCode"
                no="55"
                type="textarea"
                :rows="5"
                :disabled="isCrossTenantSEToSI"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),job.hsCode,val=>{job.hsCode=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CheckingQuestions')">
              <el-input
                v-model="form.customerCfmException"
                no="56"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.CheckingQuestions'),form.customerCfmException,val=>{form.customerCfmException=val})"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="down-four section form-column">
          <el-form :disabled="readonly" label-width="125px" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.OtherInfo') }}</span>
            <el-form-item :label="$t('SeaExport.BlType')">
              <el-select
                v-model="form.releaseType"
                no="57"
                :disabled="isCrossTenantSEToSI"
                @change="val=>{pm.cmbreleaseTypeMBL_changeHandler(val)}"
              >
                <el-option
                  v-for="(item,index) in blModeList"
                  :key="index"
                  :label="item.name"
                  :value="item.serialNumber"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlType2')">
              <cargo-advance-select
                no="58"
                :disabled="isCrossTenantSEToSI"
                :select-type="selectTypeNames.basic_data_OrderFormType"
                filterable
                :default-value="form.issuerBL"
                style="width:100%;"
                :clearable="false"
                @parentCallBack="p=>{pm.cmbissuerHBL_changeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlProperty')">
              <el-select
                no="59"
                :value="job.typeHBL||1"
                :disabled="cmbtypeHBLDisabled || isCrossTenantSEToSI"
                :clearable="false"
                @input="val=>{pm.cmbtypeHBLChangeHandler(val)}"
              >
                <el-option
                  v-for="(item,index) in BILL_TYPES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-show="job.jointMasterHBLUuid" :label="$t('SeaExport.HBLHBR')">
              <el-input no="60" :value="job.jointMasterHBL?job.jointMasterHBL.jobNo:''" :disabled="true" />
            </el-form-item>
            <!--            <el-form-item label="提单状态" class="red">-->
            <!--              <el-input :value="lblCfrState" :disabled="true" />-->
            <!--            </el-form-item> -->
            <el-form-item :label="$t('SeaExport.ReleasingStatus')" class="red">
              <el-input no="61" :value="lblReleaseState" :disabled="true" />
            </el-form-item>
            <el-form-item>
              <el-checkbox
                no="62"
                :value="form.releaseReview===1"
                :disabled="true"
                style="margin-right: 6px;"
              >{{ $t('SeaExport.DataSent') }}</el-checkbox>
              <el-checkbox no="63" :value="form.payable" :disabled="true" style="margin-right: 6px;">{{ $t('CargoMsg.Cargo_Completed') }}</el-checkbox>
              <el-checkbox no="64" :value="form.withhold" :disabled="true" style="margin-right: 0px;">{{ $t('SeaExport.CargoDetention') }}</el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfcompletion')">
              <el-date-picker
                v-model="form.agreePayDate"
                no="65"
                :disabled="true"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfCargoDetention')">
              <el-date-picker
                v-model="form.withholdDate"
                no="66"
                :disabled="true"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ParamRemark')">
              <el-select v-model="form.printParam4" no="67" filterable allow-create>
                <el-option
                  v-for="(item,index) in pm.printParam4Type"
                  :key="index"
                  :label="item.label"
                  :value="item.data"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.GenerationOfABillOfLading')">
              <el-select v-model="form.printParam5" no="68">
                <el-option
                  v-for="(item,index) in pm.printParam5Type"
                  :key="index"
                  :label="item.label"
                  :value="item.data"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ShippingCompanySCAC')">
              <el-input no="69" :value="job.carrierScac || txtCarrierScAc" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseasAgentSCAC')">
              <el-input no="70" :value="txtBookingAgentScAc" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ShipperContactTelNo')">
              <el-input v-model="form.shipperTel" no="71" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ConsigneeContactTelNo')">
              <el-input v-model="form.consigneeTel" no="72" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.NotifyPartyTelNo')">
              <el-input v-model="form.notifyTel" no="73" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CNTRNOSSEALNOS')">
              <cargo-input
                v-model="form.container"
                no="74"
                :auto-uppercase="true"
                type="textarea"
                :rows="5"
                style="width:100%"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.CNTRNOSSEALNOS'),form.container,val=>{form.container=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ReasonOfCargoDetention')">
              <el-input no="75" :value="form.withholdReason" type="textarea" :rows="5" :disabled="true" />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="76"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :disabled="!isEdit"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" no="77" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="78"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog :visible.sync="billAddressDialog.visible" :job="billAddressDialog.job" :params="billAddressDialog.params" @callback="codeSearchCallback" />
    <!-- 工作单检索弹窗 -->
    <search-bill-no-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      :lob="job.lob"
      @selected="p=>{pm.selectionItemHandler(p)}"
    />
    <!-- 抄录弹窗 -->
    <transcribe-dialog :visible.sync="transcribeDialog.visible" :job="job" @callback="transcribeCallback" />
    <!-- 反恐地址格式化弹窗 -->
    <address-format-dialog
      :visible.sync="addressFormatDialog.visible"
      :params="addressFormatDialog.params"
    />
    <!-- 批量验证弹窗 -->
    <batch-checking-window
      v-show="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 单个验证弹窗 -->
    <checking-window
      v-show="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="lob"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      no="79"
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('Payment.chargeItem')">
            <cargo-advance-select
              no="80"
              :select-type="selectTypeNames.basic_data_ChargeItem"
              filterable
              :default-value="editDialog.form.chargeItemId||''"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.chargeItemId=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ChargeClause')">
            <cargo-advance-select
              no="81"
              :select-type="selectTypeNames.basic_data_PaymentTerm"
              filterable
              :default-value="editDialog.form.paymentTermHBL"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.paymentTermHBL=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('Message.CurrencyExchangeRateIsNotMaintained1')">
            <cargo-advance-select
              no="82"
              :select-type="selectTypeNames.basic_data_Currency"
              filterable
              :default-value="editDialog.form.currency"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.currency=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContainerSize')">
            <cargo-advance-select
              no="83"
              :select-type="selectTypeNames.local_cache_EQSize"
              filterable
              :default-value="editDialog.form.eqSize"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.eqSize=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContainerType')">
            <cargo-advance-select
              no="84"
              :select-type="selectTypeNames.basic_data_EQType"
              filterable
              :default-value="editDialog.form.eqType"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.eqType=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('Payment.quantity')">
            <el-input-number
              v-model="editDialog.form.quantity"
              no="85"
              :precision="0"
              :controls="false"
              style="width:100%"
              @change="caculateAmount"
            />
          </el-form-item>
          <el-form-item :label="$t('Payment.unitPrice')">
            <el-input-number
              v-model="editDialog.form.unitRate"
              no="86"
              :precision="2"
              :controls="false"
              style="width:100%"
              @change="caculateAmount"
            />
          </el-form-item>
          <el-form-item :label="$t('Payment.amount')">
            <el-input-number
              v-model="editDialog.form.amount"
              no="87"
              :precision="2"
              :controls="false"
              style="width:100%"
              @change="editDialog.form.unitRate=editDialog.form.amount"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="88" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="89" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TabHBLPM } from './tabHBLPM'

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import searchBillNoDialog from '@/views/cargo/v0/SeaExport/components/edi/searchBillNoDialog'
import emailInput from '@/components/Cargo/Job/emailInput'
import matchHistoryDialog from '@/components/Cargo/Job/matchHistoryDialog'
import transcribeDialog from '@/components/Cargo/Job/transcribeDialog'
import addressFormatDialog from '@/views/cargo/v0/SeaExport/components/edi/addressFormatDialog'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as NumberUtils from '@/utils/NumberUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { BILL_TYPES } from '@/class/cargo/model/parameters/BillType'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { SeaImCargoDoc } from '@/class/model/booking/SeaImCargoDoc'
import { FreightCharges } from '@/class/model/booking/FreightCharges'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import SenderAndReceiver from '@/mixin/SenderAndReceiver'
import { getLoading } from '@/utils/utilBaseElement'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'

export default {
  name: 'TabHbl',
  components: {
    cargoAdvanceSelect, AutoNumberInput, cargoPackingSelect, cargoInput, billAddressDialog, searchBillNoDialog, emailInput, matchHistoryDialog, cargoRichTextarea,
    transcribeDialog, addressFormatDialog, cargoTemplateSelectorDialog, BatchCheckingWindow, CheckingWindow
  },
  mixins: [SenderAndReceiver],
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    isCrossTenantSEToSI: { // 是否跨租户出口转进口
      type: Boolean,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    viewSource: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      maxChars: 0,
      warningCount: -1,
      englishNameMaxChars: 0,
      markMaxChars: 0,
      englishNameWarningCount: -1,
      markWarningCount: -1,
      needInit: true,
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      pm: new TabHBLPM(this),
      addrPM: null, // 提单地址
      moment,
      BILL_TYPES,
      NumberUtils,
      CargoDocUtil,
      selectTypeNames: TYPE_NAMES,
      partnerManagementMode: 0,
      mergeHblData: false,
      btnPrintDisabled: true,
      hblNoDisabled: false,
      cmbtypeHBLDisabled: false,
      unlockDisabled: false,
      isUppercase: true,
      blModeList: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: '正本' },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: '电放' },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: '电放' }
      ],
      otherFieldsData: [],
      job: {},
      jointMasterHBL: {},
      jointMasterHBLjobNo: '',
      form: new SeaImCargoDoc().fillDefaultValue().getData(),
      chkConsolidationClosed: false,
      otherSelectField: '',
      otherCode: '',
      lblCfrState: '',
      lblReleaseState: '',
      txtCarrierScAc: '',
      txtBookingAgentScAc: '',
      command1: this.$t('SeaExport.CodeSearching'),
      command3: this.$t('SeaExport.CopyMblConsignee'),
      variableCss: {
        shipperLine1: '', // 发货人1
        shipperLine2: '', // 发货人2
        shipperLine3: '', // 发货人3
        shipperLine4: '', // 发货人4
        shipperLine5: '', // 发货人5
        shipperLine6: '', // 发货人6
        consigneeLine1: '', // 收货人1
        consigneeLine2: '', // 收货人2
        consigneeLine3: '', // 收货人3
        consigneeLine4: '', // 收货人4
        consigneeLine5: '', // 收货人5
        consigneeLine6: '', // 收货人6
        notifyLine1: '', // 通知人1
        notifyLine2: '', // 通知人2
        notifyLine3: '', // 通知人3
        notifyLine4: '', // 通知人4
        notifyLine5: '', // 通知人5
        notifyLine6: '', // 通知人6
        agentPartyLine1: '', // 代理信息1
        agentPartyLine2: '', // 代理信息2
        agentPartyLine3: '', // 代理信息3
        agentPartyLine4: '', // 代理信息4
        agentPartyLine5: '', // 代理信息5
        agentPartyLine6: '', // 代理信息6
        blNumber: '', // 提单份数
        packing: '', // 包装
        insideQuantity: '', // 小件数
        insidePacking: '', // 小件数包装类型
        dispatchingPlace: '', // (提单发货地)发货地
        weight: '', // 提单毛重
        cubage: '', // 提单体积
        loadingPort: '', // (提单起运港)装货港
        dischargingPort: '', // (提单卸货港)中转港
        destinationPort: '', // (提单交货地)目的港
        cargoEnglishName: '', // 英文品名
        mark: '', // 唛头
        remarks: ''// 备注
      },
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('Payment.chargeItem'),
          colId: 'chargeItemId',
          field: 'chargeItemId',
          width: 145,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        }, {
          headerName: this.$t('SeaExport.ChargeClause'),
          colId: 'paymentTermHBL',
          field: 'paymentTermHBL',
          width: 145
        }, {
          headerName: this.$t('Message.CurrencyExchangeRateIsNotMaintained1'),
          colId: 'currency',
          field: 'currency',
          width: 145
        }, {
          headerName: this.$t('SeaExport.ContainerSize'),
          colId: 'eqSize',
          field: 'eqSize',
          width: 145
        }, {
          headerName: this.$t('SeaExport.ContainerType'),
          colId: 'eqType',
          field: 'eqType',
          width: 145
        }, {
          headerName: this.$t('Payment.quantity'),
          colId: 'quantity',
          field: 'quantity',
          width: 143,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('Payment.unitPrice'),
          colId: 'unitRate',
          field: 'unitRate',
          width: 143,
          cellRenderer: params => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('Payment.amount'),
          colId: 'amount',
          field: 'amount',
          width: 143,
          cellRenderer: params => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      gridApi: null,
      autoIncrementNum: new AutoIncrementNum(),
      billAddressDialog: {
        visible: false,
        params: null,
        job: null
      },
      searchBillNoDialog: {
        visible: false,
        params: {}
      },
      emailInput: {
        visible: false,
        emailTitle: '',
        emailContent: '',
        fileIdList: ''
      },
      matchHistoryDialog: {
        visible: false
      },
      transcribeDialog: {
        visible: false
      },
      // 反恐舱单-反恐地址格式化-弹窗
      addressFormatDialog: {
        visible: false,
        params: { cargoDocs: [] }
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaImCargoDoc(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      lob: 'SE',
      editDialog: {
        visible: false,
        title: '',
        form: new FreightCharges().fillDefaultValue().getData()
      },
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      if (this.action !== 'look' && this.job && this.job.joinFlagHBL && this.job.jointMasterHBLUuid && !this.pm.isEditSingleCargoDoc) {
        return false
      } else {
        return this.action !== 'look' && this.job && !this.job.printHblZbLock
      }
    },
    btnBLConfirmDisabled() {
      return this.isEdit || !this.form.uuid
    },
    config() {
      return this.context.config
    },
    user() {
      return this.context.user
    },
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    }
  },
  watch: {
    // job上的 约价方式修改 影响 hbl 上的船名控件
    'job.bookingTerm': {
      handler: function(val) {
        this.pm.editInputVesselModel()
      }
    }
  },
  async created() {
    this.context.loading = true
    const loading = getLoading()
    await this.context.prepareData()
    this.partnerManagementMode = Number(this.config.get('PartnerManagementMode')) // 是否启用合作伙伴管理模式
    this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = Number(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    this.notUppercaseShipperConsigneNotify = Number(this.config.get('NotUppercaseShipperConsigneNotify')) !== 1
    this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.visible = true
    this.context.loading = false
    loading.close()
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        this.pm.refushLoadType()
        this.pm.checkCmbtypeHBLEnabled()
        return
      }
      this.pm.vesselList = []
      if (this.needInit) {
        this.needInit = false
        await this.pm.init()
      }
      this.job = row
      this.chkConsolidationClosed = false
      await this.pm.editingChanged()
      await this.pm.changeJob()
      await this.pm.fillView()
      this.pm.display()
    },
    async getSubmitData() {
      this.pm.validateForm()
      // await this.pm.fillModel()
      const job = { ...this.job }
      return {
        job,
        seaCargoDoc: this.job.seaCargoDoc,
        freightChargesList: this.isEdit && this.form.uuid ? this.rowData : null
        // afrAddressList: afrAddressList, 跟随doc 保存数据
      }
    },
    async endTabHandler() {
      await this.pm.fillModel()
    },
    executeTask() {
      this.pm.executeTask()
    },
    commandHandle(command) {
      switch (command) {
        case this.$t('SeaExport.CodeSearching'):
          this.billAddressDialog.visible = true
          this.billAddressDialog.params = this.form
          this.billAddressDialog.job = this.job
          break
        case this.$t('SeaExport.CopyFromTheLastTime'):
          this.pm.onCopy1()
          break
        case this.$t('SeaExport.CopyFromOtherBill'):
          this.searchBillNoDialog.params = this.form
          this.searchBillNoDialog.visible = true
          break
        case this.$t('SeaExport.CopyCargoDescriptionAndMarks'):
          this.transcribeDialog.visible = true
          break
        case this.$t('SeaExport.CopyMbl'):
          this.pm.onCopyMBL()
          break
        case this.$t('SeaExport.CopyMblConsignee'):
          this.pm.onCopy_agentParty()
          break
        case this.$t('SeaExport.CopyNominatedAgentInfo'):
          this.pm.onCopy_designationAgent()
          break
      }
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitSenderAndReceiverLine('shipper', 7, data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitSenderAndReceiverLine('consignee', 7, data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitSenderAndReceiverLine('notify', 7, data.notifyInfo)
      }
      if (data.hasOwnProperty('shipperCode')) {
        this.form['shipperCode'] = data.shipperCode || ''
      }
      if (data.hasOwnProperty('consigneeCode')) {
        this.form['consigneeCode'] = data.consigneeCode || ''
      }
      if (data.hasOwnProperty('notifyCode')) {
        this.form['notifyCode'] = data.notifyCode || ''
      }
    },
    transcribeCallback(data) {
      if (data.hasOwnProperty('cargoEnglishName')) {
        this.form.cargoEnglishName = data.cargoEnglishName
      }
      if (data.hasOwnProperty('mark')) {
        this.form.mark = data.mark
      }
    },
    /**
   * 正本打印
   */
    async originalPrint() {
      if (this.pm.originalPrintCheckSerialNo && this.form.releaseType === 1 && !this.form.serialNo) {
        this.$message.info(this.$t('Message.PleaseInputBlSerialNumberFirst'))
        return
      }
      const params = {}
      params.cargoDocUuid = this.form.uuid
      params.jobuuid = this.job.uuid
      params.DOC_UUID = this.form.uuid
      // CARGO-6750，SOP回调cargo失败。UUID中有 /导致url匹配不上了
      params.printCallBackUrl = 'services/printExec/entity/update2/CargoDoc?key=' + encodeURIComponent(this.form.uuid) + '&fieldCount=1&field1=state&value1=2'
      if (this.form.releaseType === 1) {
        const printFunc = () => {
          this.templateSelectorDialog.ctx = new SeaImCargoDoc(this.form)
          this.templateSelectorDialog.category = 'SIHBLZB'
          this.templateSelectorDialog.data = params
          // 组装打印回调函数
          this.prePrintCallback = null
          this.printedCallback = event => { this.pm.print_callback() }
          this.v2CheckCallback = async(isSure, template, entity, arms) => {
            await this.pm.v2CheckCallbackFun2(isSure, template, entity, arms)
          }
          this.templateSelectorDialog.visible = true
        }

        // 判断是否开启验证规则
        const useCheckRule = Number(this.config.get('useCheckRule')) === 1
        const checkNode = CheckRuleConstants.NODE_HBLZB_PRINT.code
        const opOffice = this.job.opOffice || 0
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (useCheckRule && hasCheckRule) {
          this.checkingManager(checkNode, printFunc, null)
        } else {
          printFunc()
        }
      } else {
        const printFunc = (category) => {
          this.templateSelectorDialog.ctx = new SeaImCargoDoc(this.form)
          this.templateSelectorDialog.category = category
          this.templateSelectorDialog.data = params
          // 组装打印回调函数
          this.prePrintCallback = null
          this.printedCallback = event => { this.pm.print_callback() }
          this.v2CheckCallback = async(isSure, template, entity, arms) => { this.pm.v2CheckCallbackFun2(isSure, template, entity, arms) }
          this.templateSelectorDialog.visible = true
        }
        // CARGO-2006 验证规则新增【电放打印】节点的控制条件
        // if (Number(this.config.get('useCheckRule')) === 1) {
        //   this.checkingManager(CheckRuleConstants.NODE_HBLDF_PRINT.code, printFunc('SIHBLZB'), null)
        // } else {
        printFunc('SIHBLDF')
        // }
      }
    },
    /**
     * 验证规则配置公用
     */
    async checkingManager(checkNode, callBack, callBack2) {
      let checkType = true
      if (this.job.masterFlag) {
        const lclSlaves = await new SeaImportJob(this.job).getLclSlaves()
        if (lclSlaves && lclSlaves.length > 0) { // 批量验证
          checkType = false
          const jobs = lclSlaves
          jobs.push(this.job) // 加入主票
          this.batchCheckingWindow.checkNode = checkNode
          this.batchCheckingWindow.jobs = jobs
          this.batchCheckingWindow.callBack = callBack
          this.batchCheckingWindow.callBack2 = callBack2
          this.batchCheckingWindow.visible = true
        }
      }
      if (checkType) { // 单个验证
        this.checkingWindow.checkNode = checkNode
        this.checkingWindow.callBack = callBack
        this.checkingWindow.callBack2 = callBack2
        this.checkingWindow.visible = true
      }
    },
    showAddressFormatDialog() {
      this.addressFormatDialog.params = { cargoDocs: [this.form] }
      this.addressFormatDialog.visible = true
    },
    showEditDialog(isNew) {
      if (isNew) {
        const newRow = new FreightCharges().fillDefaultValue().getData()
        newRow.cargoDocUuid = this.form.uuid
        this.editDialog.form = newRow
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        if (!rows[0].seq) {
          rows[0].seq = this.autoIncrementNum.getNextNum()
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    caculateAmount() {
      const form = this.editDialog.form
      form.amount = (form.quantity || 0) * (form.unitRate || 0)
    },
    save() {
      const form = this.editDialog.form
      if (!form.seq) {
        this.rowData.push(form)
      } else {
        const row = this.rowData.find(p => p.seq === form.seq)
        if (row) {
          Object.assign(row, form)
          this.gridApi.refreshCells({ force: true })
        }
      }
      this.editDialog.visible = false
    },
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        return
      }
      if (rows[0].uuid) {
        rows[0].deleted = true
        /* 强制刷新finalRowData */
        const tempRowData = this.rowData
        this.rowData = []
        this.$nextTick(() => {
          this.rowData = tempRowData
        })
      } else {
        const index = this.rowData.findIndex(p => p === rows[0])
        if (index > -1) {
          this.rowData.splice(index, 1)
        }
      }
    },
    // 组装打印参数
    getPrintData() {
      if (this.job) {
        const params = {}
        // params.jobuuid = this.job.uuid
        // params.cargoDocUuid = this.form.uuid
        // params.DOC_UUID = this.form.uuid
        // params.printCallBackUrl = 'services/printExec/sop/update/print_hbl?jobKey=' + encodeURIComponent(this.job.uuid)
        PrintTemplateUtil.buildPrintDataBySihbl(this.job, this.form, params)
        this.templateSelectorDialog.ctx = new SeaImCargoDoc(this.form)
        this.templateSelectorDialog.category = 'SIHBL'
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        this.prePrintCallback = null
        this.printedCallback = event => { this.pm.printHblPost() }
        this.v2CheckCallback = (isSure, template, entity, arms) => { this.pm.v2CheckCallbackFun(isSure, template, entity, arms) }
        this.templateSelectorDialog.visible = true
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
.form-column{
  .form-item-input{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #fff;
    border: 1px solid #E4E7ED;
    span{
      width: 40px;
      height: 28px;
      line-height: 26px;
      box-sizing: border-box;
      padding-left: 5px;
      padding-top: 1px;
    }
    /deep/.el-input {
      width: 86%;
      input{
        border: 0;
        padding-right: 0 !important;
        text-align: right;
      }
    }
  }
  .input-disabled{
    background-color: #f0f3f8 !important;
    cursor: not-allowed;
  }
}
</style>

<!-- 英文样式 -->
<style scoped lang="scss">
#app.en {
  .section::v-deep {
    &.down-first {
      min-width: 322px;
    }
    &.down-two {
      min-width: 356px;
    }
    &.down-three {
      min-width: 338px;
    }
    &.down-four {
      min-width: 336px;
    }
  }
}
</style>
